

import styled from "styled-components"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    color: ${({ theme }) => theme.mainTextColor};
    display: flex;
    align-items: center;
    input{
        width: 60%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border-style: solid;
        border-color: ${({theme}) =>  theme.mainBorderColor};
        border-width: 1px;
        border-radius: ${({radius}) => radius};
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({theme}) => theme.mainBgColor};

        &::placeholder{
            font-weight: var(--font-weight-lg);
            color: ${({theme}) => theme.mainTextColor};
        }      

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);


    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }

    .select-type-container{
        width: 40%;
        height: 40px;
        display: flex;
        border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        border-right: 1px solid ${({theme}) => theme.mainBorderColor};
        border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};
        justify-content: flex-start;
        align-items: center;
        padding-left: 10px;
        cursor: pointer;
        position: relative;


        .selected{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
        }

        .options{
            position: absolute;
            top: 39px;
            display: flex;
            flex-direction: column;
            width: calc(100% + 2px);
            height: auto;
            border: 1px solid ${({theme}) => theme.mainBorderColor};
            border-top: none;
            left: -1px;

            .option-item{
                background-color: ${({theme}) => theme.mainBgColor};
                padding: 9px 20px;
                padding-left: 10px;
                font-size: 12px;
                width: 100%;
                font-weight: var(--font-weight-md);
                color: ${({ theme }) => theme.mainTextColor};
                cursor: pointer;

                &:hover{
                    background-color: ${({theme}) => theme.secondaryBgColor};

                }
            }
        }

    }
`

const InputFilterDate = ({data, setData, name, labelText, inputWidth, dateFilterType, setDateFilterType}) => {

    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)

    // const handleChange = (e) => {

    //     if(data.toString().length < 10){
    //         setData(e.target.value.replace(/[^0-9]/g, ''))
    //     }
        
    // }
    
  return (
    <Container value={data} radius={"5px"} inputWidth={inputWidth}>
        <input type="text" id={"text"} onChange={setData} value={data} name={name}/>
        <div className="select-type-container" onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))}>
            <div className="selected">{dateFilterType === 1 ? "Saat" : "Gün"}</div>
            {
                activeSelect === name &&
                <div className="options">
                    <div className="option-item" onClick={() => {dispatch(handleActiveSelect(null)); setDateFilterType(1)}}>Saat</div>
                    <div className="option-item" onClick={() => {dispatch(handleActiveSelect(null)); setDateFilterType(2)}}>Gün</div>
                </div>
            }
        </div>
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default InputFilterDate